<template>
  <div id="page-product-details">

    <div class="my-4">
      <h2>Create Distribution List</h2>
    </div>
    <distribution-list-form
      v-model="model"
      ref="form"
      :facility-id="id"
      :disallowed-report-types="usedReportTypes"
      :loading="loading"
      :hide-add-member="true"/>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'facilities.distribution-lists.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="create"
              class="my-4"
              color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import DistributionListForm from '@/views/pages/facilities/distribution-lists/DistributionListForm';

export default {
  name: "DistributionListCreate",
  props: {
    FDO_FK: {
      default: null,
    },
  },
  components: {
    DistributionListForm,
  },
  mixins: [NotificationMixin, SaveModelMixin],
  data() {
    return {
      model: {
      },
      modelEntity: this.$api.facilities.distributionLists,
      entity: 'Distribution List',
      loading: false,
      usedReportTypes: [],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.getUsedReportTypes();
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);

      this.setReferences([
        'FacilityReportType_FK'
      ]);

      params.Facility_FK = this.id;
      // Pass from route
      params.FDO_FK = this.$attrs.FDO_PK;

      return params;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const { data } = await this.$api.facilities.distributionLists.create(params);
        this.notifySuccess('Distribution List created');

        this.$router.push({ name: 'facilities.distribution-lists.view',
          params: { id: this.id, distributionListId: data.data.FacilityReport_PK }}).catch(() =>
        {});

      } catch (e) {
        this.notifyError('Distribution List failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    },
    async getUsedReportTypes() {
      try {
        const { data } = await this.$api.facilities.underwriters.relationship('distribution-lists',
            this.$attrs.FDO_PK);
        this.usedReportTypes = data.data.map(({Type_PK}) => parseInt(Type_PK));
      } catch(e) {
        console.log(e);
      }
    }
  },
};
</script>

<style scoped>

</style>
